module.exports = __webpack_public_path__ + "content/87b3e8daf6631b7e6b41d09dd5acfcc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/flags/pl.png
// module id = 336
// module chunks = 0